<template>
  <div class="modal-content-wrap">
    <div class="lego-text-field-wrapper" style="width: 100%">
      <lego-text-field
        ref="input"
        searchable
        v-model="tmpText"
        counter="100"
        :isCounter="false"
        :placeholder="getPlaceholder"
        @click-icon="searchFields"
        @enter="searchFields"
      />
    </div>

    <MonitoringASGTable
      ref="monitoringASGTableRef"
      :searchText="textSearch"
      :scrollFixRow="scrollFixRow"
      :scrollMaxRow="scrollMaxRow"
      :height="tableHeight"
      :selectMaxItem="selectMaxItem"
      :selected="selected"
      :valueKey="valueKey"
      :productType="productType"
      @onCheck="onCheck"
      @clearSearchText="clearSearchText"
    />
  </div>
</template>
<script>
import MonitoringASGTable from './MonitoringASGTable.vue';
import validateSearchMixin from '@/mixins/validateSearch.mixin';

export default {
  name: 'AddMonitorASG',
  emits: ['selected-list'],
  mixins: [validateSearchMixin],
  props: {
    selectMaxItem: {
      type: Number,
      default: 10
    },
    selected: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: ''
    },
    valueKey: {
      type: String,
      default: 'groupIfKey'
    },
    tableHeight: {
      type: Number,
      default: 500
    },
    scrollFixRow: {
      type: Number,
      default: 13.8
    },
    scrollMaxRow: {
      type: Number,
      default: 13.8
    },
    productType: {
      type: String,
      default: 'VM'
    }
  },
  components: {
    MonitoringASGTable
  },
  computed: {
    getPlaceholder() {
      if (this.placeholder) return this.placeholder;
      return $t('searchLabel.searchLike', { VPC: $t('searchLabel.monTarget') });
    }
  },
  data() {
    return {
      tmpText: '',
      objectTypeList: [],
      objectTypeName: '',
      textSearch: ''
    };
  },
  methods: {
    onCheck(selectedItems) {
      this.$emit('selected-list', selectedItems);
    },
    searchFields() {
      this.textSearch = this.tmpText;
      this.$refs.monitoringASGTableRef.execSearch(true, this.textSearch);
      this.$refs.input.blur();
    },
    resetSearchField() {
      this.tmpText = '';
      this.textSearch = '';
      this.$refs.monitoringASGTableRef.execSearch(true);
    },
    execSearch() {
      this.$refs.monitoringASGTableRef.execSearch();
    },
    clearSearchText() {
      this.textSearch = '';
      this.tmpText = '';
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-content-wrap {
  width: 100%;
}
.lego-select-search {
  display: flex;
  align-content: center;
  justify-content: space-between;
}

.lego-text-field-wrapper {
  display: inline-block;
}

.badge-text-wrapper {
  display: flex;
  align-items: center;
}

:deep .listTargetItem {
  display: inline-block;
  color: #364fc7;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

:deep .scpmSubTitleContainer .scpmSubTitle {
  font-size: 14px !important;
}

.scpm-drag-wrap {
  padding-top: 20px;
}

:deep .added-list-box {
  margin-top: 5px !important;
}
</style>
